import { Link } from "react-router-dom";
import { Wordmark } from "@/components/brand/Wordmark";

const columns = [
  {
    title: "Product",
    links: [
      { label: "Features", href: "#features" },
      { label: "Pricing", href: "#pricing" },
      { label: "FAQ", href: "#faq" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", href: "#" },
      { label: "Contact", href: "#" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy", href: "/privacy" },
      { label: "Terms", href: "/terms" },
    ],
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-border bg-background"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-5">
            <Link
              to="/"
              data-testid="footer-wordmark"
              className="font-display text-2xl tracking-tight"
            >
              <Wordmark className="h-10" />
            </Link>
            <p className="mt-4 text-sm text-muted-foreground max-w-xs leading-relaxed">
              The essential operating system for luxury wardrobe management.
            </p>
          </div>

          <div className="md:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
            {columns.map((col) => (
              <div key={col.title}>
                <p className="text-[11px] uppercase tracking-[0.25em] text-foreground/60 font-medium mb-4">
                  {col.title}
                </p>
                <ul className="space-y-3">
                  {col.links.map((link) => {
                    const isInternal = link.href.startsWith("/");
                    if (isInternal) {
                      return (
                        <li key={link.label}>
                          <Link to={link.href}
                            data-testid={`footer-${col.title.toLowerCase()}-${link.label.toLowerCase()}`}
                            className="text-sm text-foreground/80 hover:text-oxblood transition-colors">
                            {link.label}
                          </Link>
                        </li>
                      );
                    }
                    return (
                      <li key={link.label}>
                        <a
                          href={link.href}
                          data-testid={`footer-${col.title.toLowerCase()}-${link.label.toLowerCase()}`}
                          className="text-sm text-foreground/80 hover:text-oxblood transition-colors"
                        >
                          {link.label}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Wardrobe Index. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground tracking-wide">
            Made for the wardrobe room.
          </p>
        </div>
      </div>
    </footer>
  );
}
